// extracted by mini-css-extract-plugin
export default {"component":"marketing-list_component__qsmFA","createBtn":"marketing-list_createBtn__-b0mq","list":"marketing-list_list__UYZjP","loading":"marketing-list_loading__el7n1"};